import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Audit from "@/pages/Audit";
import Dashboard from "@/pages/Dashboard";
import Portal from "@/pages/Portal";

const Protected = ({ children, role }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/auth" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "ca" ? "/dashboard" : "/portal"} replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/dashboard/*"
              element={
                <Protected role="ca">
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/portal/*"
              element={
                <Protected role="client">
                  <Portal />
                </Protected>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
